var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#028383;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9,0C4,0,0,4,0,9c0,5,4,9,9,9c5,0,9-4,9-9C18,4,14,0,9,0z M1.4,9c0-0.3,0-0.6,0-0.8l2.1-0.3 c0.4-0.1,0.7,0.1,1,0.3c0.3,0.3,0.4,0.6,0.3,1L4.6,9.9c-0.3,1.6,0.5,3.2,2,3.9c0.7,0.3,1,1.1,0.8,1.8l-0.2,0.9 C3.9,15.6,1.4,12.6,1.4,9z M8.6,16.6l0.2-0.8c0.3-1.3-0.3-2.7-1.5-3.3c-0.9-0.5-1.4-1.5-1.3-2.5l0.1-0.7C6.2,8.5,6,7.8,5.4,7.2 S4.1,6.4,3.3,6.5L1.7,6.8c1-3.1,3.9-5.4,7.3-5.4c2.2,0,4.1,0.9,5.5,2.3L14,4.1c-0.2,0.1-0.4,0.2-0.7,0.2h-3c-0.8,0-1.5,0.4-1.9,1.2 C8,6.3,8.2,7.4,9,8l1.8,1.5c1.2,1,1.9,2.6,1.7,4.2l0,0.2c-0.1,0.6-0.2,1.2-0.4,1.7l-0.2,0.6c-0.9,0.3-1.8,0.5-2.8,0.5 C8.9,16.6,8.7,16.6,8.6,16.6z M13.6,15.1c0.1-0.4,0.2-0.8,0.2-1.1l0-0.2c0.2-2.1-0.6-4.1-2.2-5.4L9.9,6.9C9.6,6.7,9.5,6.4,9.7,6 c0.1-0.3,0.4-0.4,0.7-0.4h3c0.5,0,1.1-0.2,1.5-0.5l0.5-0.4C16.2,6,16.6,7.4,16.6,9C16.6,11.5,15.5,13.7,13.6,15.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicIcon);
export default __webpack_public_path__ + "static/media/publicIcon.209cd67983c8d0da85b1dbd976cb53f0.svg";
export { ForwardRef as ReactComponent };